







import mixins from 'vue-typed-mixins';
import { ReportNode, ReportContext } from '@/utils/ReportUtils';
import BookshelfDisplayVue from '@/components/resource/BookshelfDisplay.vue';

export default mixins().extend({
  components: {
    BookshelfDisplay: BookshelfDisplayVue,
  },

  props: {
    node: {
      type: Object as () => ReportNode,
    },
    context: {
      type: Object as () => ReportContext,
    },
  },

  async mounted() {
    //
  },

  methods: {
    async loadBookshelf() {},
  },
});
